export default __webpack_public_path__ + "static/media/rectangle.6afd4a26.mp3";